import {ShapeCommand} from '../commands.template';
import {getActivityMinWH} from '../../diagram-render/styles/styles.util';
declare let mxUtils: any;

export class ActivityChangeFooterTextCommand extends ShapeCommand {
  private readonly SFA_TOP_MARGIN = 15;
  private readonly SFA_BOTTOM_MARGIN = 20;
  private readonly FOOTER_CONTAINER_SIZE = 35 + this.SFA_TOP_MARGIN;
  services: any;
  firstAction: boolean;
  mxKey: number;
  reverseData: any;
  visibleResources = 0;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public prepareData() {
    const activityJson = this.services.jsonHandlerSvc.get().activities.find(a => {
      return Number(a.mxKey) === Number(this.object.mxKey);
    });

    this.visibleResources = (activityJson?.resources || []).reduce(
      (acc, curr) => (curr.hidden || curr.main ? acc : ++acc),
      0
    );
    this.reverseData = {
      mxKey: activityJson.mxKey,
      footerText: activityJson.footerText
    };

    return this;
  }

  public execute() {
    super.execute();
    const action = {
      changeActivity: {
        mxKey: this.object.mxKey,
        footerText: this.services.sanitizeXssService.sanitizeXssContent(this.object.footerText)
      }
    };

    if (!this.object.footerText) {
      this.applyGraphChanges(false);
    }

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.mxKey);
  }

  public reverse() {
    super.reverse();
    const action = {
      changeActivity: this.reverseData
    };

    if (this.reverseData.footerText && !this.object.footerText) {
      this.applyGraphChanges(true);
    }

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.mxKey);
  }

  private applyGraphChanges(add: boolean) {
    let dy = add ? this.FOOTER_CONTAINER_SIZE : -this.FOOTER_CONTAINER_SIZE;

    if (!this.visibleResources) {
      dy += add ? this.SFA_BOTTOM_MARGIN : -this.SFA_BOTTOM_MARGIN;
    }

    const graph = this.services.editorRegistrySvc.getGraph();
    const cell = graph.model.getCell(Number(this.object.mxKey));
    const geo = cell.geometry.clone();
    const {minHeight} = getActivityMinWH(
      cell.getJson(),
      this.services.diagramTypeConfigService.currentType()
    );

    graph.getModel().beginUpdate();
    cell.skipUndo = true;
    graph.getModel().setStyle(cell, mxUtils.setStyle(cell.style, 'minHeight', minHeight + dy));
    graph.getModel().setGeometry(cell, geo);
    graph.getModel().endUpdate();
  }

  private redrawActivity(mxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(mxKey))
      .comp.instance.setupFromJson();
  }
}
